"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutPropertiesLoose"));
var _react = _interopRequireDefault(require("react"));
var _reactMarkdown = _interopRequireDefault(require("react-markdown"));
var _renderers = _interopRequireDefault(require("react-markdown/lib/renderers"));
var _text = require("../text");
var _excluded = ["level"],
  _excluded2 = ["renderers"];
var Heading = function Heading(_ref) {
  var level = _ref.level,
    props = (0, _objectWithoutPropertiesLoose2.default)(_ref, _excluded);
  switch (level) {
    case 1:
      return /*#__PURE__*/_react.default.createElement(_text.PageTitle, props);
    case 2:
      return /*#__PURE__*/_react.default.createElement(_text.Headline, props);
    case 3:
      return /*#__PURE__*/_react.default.createElement(_text.SubHeadline, props);
    case 4:
      return /*#__PURE__*/_react.default.createElement(_text.Title, props);
    default:
      return /*#__PURE__*/_react.default.createElement(_text.Title, props);
  }
};
var zeusRenderers = Object.assign({}, _renderers.default, {
  heading: Heading,
  // Temp fix: react-markdown invented their own heuristics for checking if an
  // element is a react element, instead of using react-is, so any new element
  // (like React.forwardRef) is considered "not renderable".
  // I'll PR a fix to react-markdown but this workaround solves it meanwhile.
  link: function link(props) {
    return /*#__PURE__*/_react.default.createElement(_text.Link, props);
  },
  paragraph: function paragraph(props) {
    return /*#__PURE__*/_react.default.createElement(_text.Paragraph, props);
  }
});
var ZeusMarkdown = function ZeusMarkdown(_ref2) {
  var renderers = _ref2.renderers,
    props = (0, _objectWithoutPropertiesLoose2.default)(_ref2, _excluded2);
  return /*#__PURE__*/_react.default.createElement(_reactMarkdown.default, Object.assign({
    renderers: Object.assign({}, zeusRenderers, renderers)
  }, props));
};
ZeusMarkdown.defaultProps = {
  renderers: {}
};
var _default = exports.default = ZeusMarkdown;